export const URL = {
    IMAGE: process.env.REACT_APP_IMAGE_URL,
    SOCKET: process.env.REACT_APP_SOCKET_API_KEY,
    API: process.env.REACT_APP_API_KEY,
}
export const FILE = {
    IMAGES: /\.(svg|png|apng|jpeg|jpg|ico|hdr|bmp|webp|gif|tiff|tif|jp2|rgb|dds|cur|tga|heic|jfif|pgm|jpe|xpm|exr|map|ppm|g3|wbmp|jbg|pcx|pdb|avif|jps|rgba|heif|fax|xbm|yuv|pcd|pict|xwd|pal|vips|pgx|pbm|jbig|picon|ras|pct|fts|hrz|ipl|mng|mtv|otb|palm|pam|pfm|pnm|rgbo|sgi|sun|uyvy|viff|xv|g4|rgf|six|sixel|jif|jfi)$/i,
    VIDEO: /\.(avi|wmv|mpeg|webm|mov|mpg|divx|mpeg-2|3gp|flv|swf|m4v|ogv|mkv|mjpeg|vob|xvid|mts|av1|ts|avchd|hevc|asf|mxf|m2v|3g2|rmvb|m2ts|wtv|f4v|rm|mp4)$/i,
    AUDIO: /\.(mp3|wav|ogg|wma|m4a|flac|mp2|aac|aiff|m4r|amr|ac3|opus|gsm|wve|w64|caf|fssd|vox|dts|amb|txw|au|spx|wv|voc|tta|ra|oga|pvf|prc|maud|8svx|snd|sndr|sndt|avr|cdda|cvs|cvsd|cvu|dvms|vms|fap|paf|sou|gsrt|hcom|htk|ima|ircam|sln|sph|nist|smp|sd2)$/i,
};

export const CONSTANTS = {
    PREMIERE_TIME: 15,
    MOVIE_END_TIME: 5,
    PAGINATION_LIMIT: 20,
    AWARDS_SPONSORS: ['Next Audience', 'U.S. Dramatic', 'U.S. Documentary'],
    AWARDS: ['World Dramatic', 'World Documentary'],
    MAX_LENGTH: 50,
    JOIN_EXPIRES: 180,
    WAITING_ROOM_BUFFER: 5
}

export const STATE_PRO =  ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Dist. Columbia', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming', 'Alberta', 'British Columbia', 'Labrador', 'Manitoba', 'New Brunswick', 'Newfoundland', 'Nova Scotia', 'Nunavut', 'North West Terr', 'Ontario', 'Prince Edward Is', 'Quebec', 'Saskatchewen', 'Yukon']

export const selectCameras = ['ARRI','AATON', 'BLACKMAGIC', 'CANON', 'GOPRO', 'Kinefinity', 'PANASONIC', 'PANAVISION','PHANTOM', 'RED', 'SONY', 'OTHER',]

export const selectLens = ['7artisans', 'ANGENIEUX', 'ARRI/Zeiss', 'ATLAS LENS CO.', 'BLAZAR',  'CANON', 'COOKE', 'DZOFilm', 'FUJINON', 'HAWK', 'IRIX', 'KOWA', 'LEICA', 'LEITZ', 'MEIKE', 'MITAKON Zhongyi', 'NiSi', 'PANASONIC', 'PANAVISION', 'ROKINON', 'SAMYANG', 'SCHNEIDER', 'SIGMA', 'Sirui', 'SLR MAGIC',  'SONY',  'TAMRON', 'TOKINA', 'VENUS OPTICS', 'VILTROX', 'ZEISS', 'OTHER ']

export const lensOption = {
    '7artisans': ['Other'],
    ANGENIEUX: ['Optimo Anamorphic', 'Optimo', 'Type EZ', 'Other'],
    ARRIZeiss: ['Master Anamorphic', 'Master Primes', 'Ultra Primes', 'Compact Primes', 'Other'],
    ATLASLENSCO: ['Orion Series', 'Mercury Series'],
    BLAZAR: ['Other'],
    CANON: [ 'RF "Still" Series', 'EF "Still" Series', 'CN-R Cinema Series', 'CN-E Cinema Series', 'CINE-SERVO Series', 'COMPACT-SERVO Series', 'Flex Zoom Series', 'Sumire Prime Series', 'FD lenses', 'K35', 'Other' ],
    COOKE: [ "5i", "Anamorphic", "Panchro Classic", "Mini S4i", "S4i", "S7i", "SP3", "Varotal", "Other" ],
    DZOFilm:['Other'],
    FUJINON: ['MK series', 'Premista Series', 'Cabrio Series','Premier series', 'Other'],
    HAWK: ['V-Lite Series', 'V-Series', 'Other'],
    IRIX: ['Other'],
    KOWA: ['Anamorphics', 'Spherical Primes', 'Other'],
    LEICA: ['Other'],
    LEITZ: ['Other'],
    MEIKE: ['Other'],
    MITAKONZhongyi: ['Other'],
    NiSi: ['Other'],
    PANASONIC: ['Other'],
    PANAVISION: ['Anamorphic', 'Primo', 'Super Panavision 70 ', 'Other'],
    ROKINON: ['XEEN series', 'Other'],
    SAMYANG: ['Other'],
    SCHNEIDER: ['Other'],
    SIGMA: ['Classic Art', 'High speed', 'High speed Art', 'Other'],
    Sirui: ['Other'],
    SLRMAGIC: ['Other'],
    SONY: ['CineAlta', 'Other'],
    TAMRON: ['Other'],
    TOKINA: ['Cinema', 'Cinema ATX', 'Cinema Vista series', 'Other'],
    VENUSOPTICS:['Other'],
    VILTROX:['Other'],
    ZEISS: ['Master Anamorphic', 'Master Primes', 'Supreme series', 'Photo Lenses', 'Ultra Primes', 'Other'],
    OTHER : ['Other']
}

export const cameras = {
    ARRI: ['Alexa', 'Alexa LF', 'Alexa Mini', 'Alexa 35', 'Alexa 65', 'Amira', 'Arriflex Film Camera', 'Other'],
    AATON: ['A-Minima', 'Delta', 'Penelope', 'Xtera', 'Other'],
    BLACKMAGIC: ["Cinema Camera 6K", "Cinema Camera 6K G2", "URSA Cine 12K", "URSA Cine 17K", "PYXIS 6K", "PYXIS 12k", "URSA Mini Pro 12K", "URSA Mini Pro 4.6K", "URSA Cine Immersive", "Pocket Cinema Camera", "Micro Cinema Camera", "URSA Mini", "Other"],
    CANON: [ "C700 FF", "C700", "C500 Mark II", "C500", "C400", "C300 Mark III", "C300 Mark II", "C300", "C200", "C100", "C100 Mark II", "C70", "C80", "EOS R5 C", "ME20F-SH or ME200S-SH", "XA and XF Pro Camcorder Series", "ILC", "Other" ],
    GOPRO: ['Hero', 'Other'],
    Kinefinity:[ "MAVO Edge 8K", "MAVO Edge 6K", "MAVO S35 MKII", "MAVO LF MKII" ],
    // NoCamera: ['Animation', 'Archival Footage'],
    // SpeedGrade: ['Alexa', 'Alexa 65', 'Alexa LF', 'Alexa Mini', 'Amira', 'Arriflex Film Camera'],
    PANASONIC: [ "EVA1", "GH5, GH5 II or GH5s", "GH6", "GH7", "S1 Series", "S1H", "S5 II Series", "S9", "VariCam Pure", "VariCam HS", "VariCam 35", "VariCam LT", "Other" ],
    PANAVISION: ['Genesis', 'Millenium', 'Platinum', 'DXL', 'Other'],
    PHANTOM: ['Gold', 'Flex', 'Miro ', 'Other'],
    RED: [ "Raptor", "Komodo", "Komodo X", "Epic", "Dragon", "Monstro", "Raven", "Scarlet", "Weapon", "Other"],
    SONY: [ "LR1", "A7S Series", "A7R Series", "A7 Series", "A9 Series", "Alpha 1", "ZV Series", "FX30", "FX3", "XF6", "FX9", "F5", "F55", "F65", "FS5 Series", "FS7 Series", "FS700", "Venice", "Venice 2", "BURANO", "FR7", "Other" ],
    // SpecialtyBrand: ['Other'],
    OTHER: ['Did not use a camera - Animation or Archival Footage','Specialty Brand']
}

export const commonOption = {
    Flag1: ['Purchase', 'Rent', 'N/A'],
    Flag2: ['Anamorphic', 'Spherical', 'Both', 'N/A'],
    Flag3: ['Format', 'Features', 'Brand Reputation', 'Recommendations from Colleagues or Friends', 'Price', 'Familiarity with Brand', 'Availability at Rental House', 'Rental House Staff', 'Size/Weight', 'Other'],
    SoftwareData: ['Avid Media Composer','Adobe Premiere', 'Final Cut Pro X', 'Final Cut Pro - earlier version', 'DaVinci Resolve', 'Other'],
    Flag5: ['Yes', "No, we didn't use any Adobe products"],
    Flag6: ['PC- Dell', 'PC- HP', 'Mac- Apple', 'Other'],
    Flag7: ['Storage Devices/Hard Drives', ' Laptop/Desktop Computer', 'Audio Software/Hardware(pre/post)', 'Sound Mixing Software', 'Graphics Software', 'Mobile Phone Technology', 'Game Engine', 'VR/AR Headset', 'None'],
    Flag8: ['I did not use a 3D real-time engine', 'Unity', 'Unreal', 'Adobe Aero', ' In-House/proprietary', 'Other'],
    Flag9: ['Yes', 'No'],
    Flag10: ['Kickstarter', 'Indie-gogo', 'Slated', 'Rally', 'Crowdfunder', 'RocketHub', 'Other', 'None'],
}